// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"e57936de","401":"01012328","423":"3d605ad5","514":"198063f1","538":"cbf28011","607":"422274dd","974":"479be55a","977":"0d8121c3"}[chunkId] + ".chunk.js";
};